module.exports = __webpack_public_path__ + "img/nissan-rogue.13230aaa.jpg";